import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import { Container } from '../../../../../../components/SearchForm/components/DestinationWidget/components/BlockLastSearches/components/Container.js';
import { SearchItem } from '../../../../../../components/SearchForm/components/DestinationWidget/components/BlockLastSearches/components/SearchItem.js';
import { useStorage } from '../../../../../../components/SearchForm/components/DestinationWidget/components/BlockLastSearches/hooks/useStorage.js';
import { Divider, LabelMediumBold, Stack } from '../../../../../../primitives/index.js';
import { SPACING_MEDIUM, SPACING_SMALL } from '../../../../../../utils/spacingLegacy.js';
export const BlockLastSearches = ({
  onClickItem,
  config
}) => {
  const {
    t
  } = useTranslation();
  const {
    remove,
    data
  } = useStorage();
  if (data.length === 0) {
    return null;
  }
  return _jsxs(Container, {
    children: [_jsx(LabelMediumBold, {
      children: t('searchForm:destinationWidget.lastSearchesTitle')
    }), _jsx(Stack, {
      spacing: SPACING_SMALL,
      divider: true,
      dividerProps: {
        category: 'primary',
        type: 'dotted'
      },
      children: data.slice(0, 3).map((data, index) => _jsx(SearchItem, {
        data: data,
        onClick: onClickItem,
        config: config,
        onRemove: () => remove(index)
      }, index))
    }), _jsx(Stack, {
      spacing: SPACING_MEDIUM,
      children: _jsx(Divider, {})
    })]
  });
};